import script from "./PushCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PushCenter.vue?vue&type=script&setup=true&lang=js"

import "./PushCenter.vue?vue&type=style&index=0&id=2369ad57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2369ad57"]])

export default __exports__